import React, { useState, useEffect } from "react";
import DialogBox from "../../atoms/DiaglogBox";
import { Form, Upload, Input } from "antd";
import toast from "react-hot-toast";
import { uploadDocument } from "../../../utils/API/uploadDocuments";
import { motion } from "framer-motion";
import { Link } from "react-router-dom";
import Button from "../../atoms/Button";
import UploadIcon from "../../svgs/upload.svg";
import {
  FileAddOutlined,
  DeleteOutlined,
  LoadingOutlined,
} from "@ant-design/icons";
import { submitReceipt } from "../../../utils/API/submitReceipt";
import { useDispatch } from "react-redux";

const allowedFileTypes = [
  "image/jpeg",
  "image/jpg",
  "image/png",
  "application/pdf",
];

const inputClass = "border-2 border-b-2 rounded-none";

const UploadFiles = ({
  open,
  onCancel,
  onSubmit,
  transactionId,
  updateData,
}) => {
  const dispatch = useDispatch();
  const [document, setDocument] = useState([]);
  const [loading, setLoading] = useState(false);
  const [form] = Form.useForm();

  const [submitLoading, setSubmitLoading] = useState(false);

  useEffect(() => {
    if (document.length === 0) {
      form.resetFields(["payment_receipt"]);
    } else {
      form.setFieldValue("payment_receipt", document[0].url);
    }
  }, [document, form]);

  useEffect(() => {
    form.setFieldsValue({
      ref_no: transactionId,
    });
  }, [transactionId, form]);

  const closeHandler = () => {
    form.resetFields();
    setDocument([]);
    setLoading(false);
    onCancel();
  };

  const submitHandler = async (data) => {
    try {
      setSubmitLoading(true);
      await submitReceipt(transactionId, data, dispatch);
      toast.success("Submitted Successfully..");
      updateData();
      setDocument([]);
      onSubmit();
    } catch (error) {
      toast.error(error.message);
    } finally {
      setSubmitLoading(false);
    }
  };

  const onUpload = async ({ file, onSuccess, onError }) => {
    if (document.length === 1) {
      toast.error("Maximum 1 file can be uploaded");
      return;
    }

    const isAllowedType = allowedFileTypes.includes(file.type);
    if (!isAllowedType) {
      const fileExtensionsString = allowedFileTypes
        .map((fileType) => {
          const parts = fileType.split("/");
          return parts[1];
        })
        .join(", ");
      toast.error(`You can only upload ${fileExtensionsString} files!`);
      return;
    }

    const isLt2M = file.size / 1024 / 1024 < 2;
    if (!isLt2M) {
      toast.error("File must be smaller than 2MB!");
      return;
    }

    try {
      setLoading(true);
      const response = await uploadDocument(
        file,
        `${transactionId}_payment_receipt`,
        document.length + 1,
        1,
        dispatch
      );
      onSuccess();
      setDocument([{ name: file.name, url: response.data, status: "done" }]);
      setLoading(false);
    } catch (error) {
      onError();
      setLoading(false);
      toast.error(error.message);
    }
  };

  return (
    <DialogBox
      width={425}
      open={open}
      onCancel={closeHandler}
      closeIcon={false}
    >
      <div className="px-4 pb-8">
        <h1 className=" font-semibold text-2xl pt-2">Add Transaction Proof</h1>
        <hr className="mb-2 border-[1px]" />
        <Form
          form={form}
          onFinish={submitHandler}
          noValidate
          className="offset-form font-spaceGrotesk"
        >
          <Form.Item
            label="Refrence number"
            name={"ref_no"}
            className="m-0 p-0"
            labelAlign="left"
            labelCol={{ span: 24 }}
            wrapperCol={{ span: 24 }}
            rules={[
              {
                required: true,
                message: `Please enter refrence number`,
              },
            ]}
          >
            <Input className={inputClass} placeholder="Refrence No." disabled />
          </Form.Item>

          <Form.Item
            label="Transaction Proof"
            name={"payment_receipt"}
            className="m-0 p-0 pt-6"
            labelAlign="left"
            labelCol={{ span: 12 }}
            wrapperCol={{ span: 24 }}
            rules={[
              {
                required: true,
                message: `Please upload file`,
              },
            ]}
          >
            <Upload
              disabled={loading}
              customRequest={onUpload}
              maxCount={1}
              showUploadList={false}
            >
              <Button
                varient={"primary"}
                color={"blue"}
                className={
                  "px-3 py-1 rounded-[0.19rem] text-xs text-white font-medium flex justify-center gap-x-2 items-center font-spaceGrotesk"
                }
              >
                <img src={UploadIcon} alt="upload icon" className="w-3" />
                Upload
                {loading && <LoadingOutlined className="ml-2" />}
              </Button>
            </Upload>
          </Form.Item>

          {document.length > 0 && (
            <div className="mb-4 border p-2 rounded-lg mt-8">
              {document.map(({ name: fileName, url }, index) => (
                <motion.div
                  initial={{ opacity: 0, y: 10 }}
                  animate={{ opacity: 1, y: 0 }}
                  transition={{ duration: 0.2 }}
                  className="group hover:bg-gray-100 px-2 py-1 flex justify-between items-center rounded-md"
                  key={`${"goverment_issued_id"}_${index}`}
                >
                  <span>
                    <FileAddOutlined className="mr-2" />
                    <Link
                      to={url}
                      target="_blank"
                      className="hover:text-blue-800"
                    >
                      {" "}
                      {fileName}
                    </Link>
                  </span>
                  <DeleteOutlined
                    className="hidden group-hover:block cursor-pointer hover:text-blue-800"
                    onClick={() => {
                      setDocument([]);
                    }}
                  />
                </motion.div>
              ))}
            </div>
          )}

          <div className="flex px-6 mt-4 gap-x-6">
            <Button
              // onClick={submitHandler}
              disabled={submitLoading}
              type="submit"
              varient="primary"
              color="blue"
              className="w-1/2 text-sm font-bold text-white h-10"
            >
              {submitLoading ? <LoadingOutlined /> : "Submit"}
            </Button>
            <Button
              onClick={closeHandler}
              varient="primary"
              className="w-1/2  text-sm font-bold  text-blue-800  bg-[#4361EE26]  "
            >
              Cancel
            </Button>
          </div>
        </Form>
      </div>
    </DialogBox>
  );
};

export default UploadFiles;
